import { Icon } from '@ps/isp-web-component-library';
import { CloseMedium } from '@ps/isp-web-component-library/icons/CloseMedium';
import type { RunnerId } from '@ps/isp-web-services-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import { TXTCLI_Remove } from './RemoveButton.messages.json';
import styles from './RemoveButton.scss';

interface Props {
  runnerId: RunnerId;
}

const RemoveButton: React.FC<Props> = ({ runnerId }) => {
  const { formatMessage } = useRegulatoryIntl();
  const { betSlip } = useDispatch<Dispatch>();
  const selectedPromotionPicker = useSelector(select.betSlip.selectedPromotionPicker);

  return (
    <button
      type="button"
      title={formatMessage(TXTCLI_Remove)}
      className={styles.button}
      onClick={() => betSlip.selectionRemoved(runnerId)}
      disabled={Boolean(selectedPromotionPicker)}
    >
      <Icon icon={CloseMedium} size="sm" />
    </button>
  );
};

export default RemoveButton;
